import Model from "~~/package/mapper/Model";
import { createModel } from "~~/package/utils/ModelUtil";

export class ProSkillAssureAiRecommendUsageModel extends Model {
    constructor(
        public limit: number = 0,
        public used: number = 0,
        public remaining: number = 0,
        public unlimited: boolean = false
    ) {
        super();
    }

    public static create(model: Partial<ProSkillAssureAiRecommendUsageModel>): ProSkillAssureAiRecommendUsageModel {
        return createModel<ProSkillAssureAiRecommendUsageModel>(ProSkillAssureAiRecommendUsageModel, { ...model });
    }
}
